import { initNavbar } from "@modules/navbar";
import { initHero } from "@modules/hero";

require("./bootstrap");

initNavbar();
initHero();
